/**
 * ⓘ — Erklärungen eine Ebene tiefer (Phase 5, 28.09.2026).
 *
 * Matze: „so userfreundlich wie möglich … ohne dass man von Informationen erschlagen
 * wird." Sichtbar bleibt je Block eine Zeile Zustand; Begründungen, Messwerte und
 * Sonderfälle stehen hier. Warnungen vor echtem Schreiben gehören NICHT hierher —
 * die bleiben sichtbar.
 *
 * Klick öffnet, Klick daneben / Esc schließt. Kein Hover-only: auf dem Laptop-Trackpad
 * und für längere Texte ist ein fester Klick verlässlicher.
 */
import { useEffect, useRef, useState, type ReactNode } from 'react';
import { Info as InfoIcon } from 'lucide-react';

export default function Info({ children, titel = 'Mehr dazu', breit = false }: {
  children: ReactNode;
  titel?: string;
  /** Für längere Erklärungen (Listen, mehrere Absätze). */
  breit?: boolean;
}) {
  const [offen, setOffen] = useState(false);
  const ref = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (!offen) return;
    const zu = (e: MouseEvent) => { if (ref.current && !ref.current.contains(e.target as Node)) setOffen(false); };
    const esc = (e: KeyboardEvent) => { if (e.key === 'Escape') setOffen(false); };
    document.addEventListener('mousedown', zu);
    document.addEventListener('keydown', esc);
    return () => { document.removeEventListener('mousedown', zu); document.removeEventListener('keydown', esc); };
  }, [offen]);

  return (
    <span ref={ref} className="relative inline-flex align-middle">
      <button
        type="button"
        onClick={e => { e.stopPropagation(); setOffen(o => !o); }}
        aria-label={titel}
        aria-expanded={offen}
        className="rounded-full p-0.5 text-[#8A8984] hover:bg-[#F0F0EC] hover:text-[#1A1A1A]"
      >
        <InfoIcon className="h-3.5 w-3.5" />
      </button>
      {offen && (
        <span
          role="dialog"
          className={`absolute left-0 top-6 z-30 space-y-2 rounded-lg border border-[#DAD9D9] bg-white p-3 text-left text-xs font-normal leading-relaxed text-[#1A1A1A] shadow-lg ${breit ? 'w-[28rem]' : 'w-72'}`}
          onClick={e => e.stopPropagation()}
        >
          {children}
        </span>
      )}
    </span>
  );
}
